/**
 * @generated SignedSource<<a2ab4549740a08c60a5a377fd202454c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type InitializeVirtualizer_groupResults$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly firstGroup?: {
    readonly id: string;
    readonly issues: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly issueId: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      };
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "InitializeVirtualizer_groupResults";
};
export type InitializeVirtualizer_groupResults$key = {
  readonly " $data"?: InitializeVirtualizer_groupResults$data;
  readonly " $fragmentSpreads": FragmentRefs<"InitializeVirtualizer_groupResults">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetsInput"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetsScope"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isPaginating"
    },
    {
      "kind": "RootArgument",
      "name": "settings"
    },
    {
      "kind": "RootArgument",
      "name": "viewConfigInput"
    }
  ],
  "kind": "Fragment",
  "name": "InitializeVirtualizer_groupResults",
  "selections": [
    {
      "concreteType": "JiraSpreadsheetGroupEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraSpreadsheetGroup",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ]
        }
      ]
    },
    {
      "condition": "isPaginating",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "concreteType": "JiraSpreadsheetGroup",
              "kind": "LinkedField",
              "name": "firstGroup",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "fieldSetsInput",
                      "variableName": "fieldSetsInput"
                    },
                    {
                      "kind": "Literal",
                      "name": "first",
                      "value": 50
                    },
                    {
                      "kind": "Variable",
                      "name": "scope",
                      "variableName": "fieldSetsScope"
                    },
                    {
                      "kind": "Variable",
                      "name": "settings",
                      "variableName": "settings"
                    },
                    {
                      "kind": "Variable",
                      "name": "viewConfigInput",
                      "variableName": "viewConfigInput"
                    }
                  ],
                  "concreteType": "JiraIssueConnection",
                  "kind": "LinkedField",
                  "name": "issues",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraIssueEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "JiraIssue",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "issueId"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "concreteType": "PageInfo",
                      "kind": "LinkedField",
                      "name": "pageInfo",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "hasNextPage"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraSpreadsheetGroupConnection"
};
})();

(node as any).hash = "041a2f3e0cbd55d5bc5ccc47012c8bc7";

export default node;
